import IndicatorEvolutionContainer from './IndicatorEvolutionContainer'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import ReduxActions from 'redux/actions'

const mapStateToProps = state => {
  return {
    selectedRegionId: state.REGIONS.selectedRegionId
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setRegionsData: regionsData => dispatch(ReduxActions.setRegionsData(regionsData)),
    setReferenceRegionsData: referenceRegionsData => dispatch(ReduxActions.setReferenceRegionsData(referenceRegionsData)),
    setSameCountryRegionsData: sameCountryRegionsData => dispatch(ReduxActions.setSameCountryRegionsData(sameCountryRegionsData)),
    setIndicatorsData: indicatorsData => dispatch(ReduxActions.setIndicatorsData(indicatorsData)),
    setIndicatorsLastUpdated: lastUpdated => dispatch(ReduxActions.setIndicatorsLastUpdated(lastUpdated)),
    setCountriesData: countriesData => dispatch(ReduxActions.setCountriesData(countriesData)),
    setSelectedRegionCountryMeta: countryMeta => dispatch(ReduxActions.setSelectedRegionCountryMeta(countryMeta))
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(IndicatorEvolutionContainer)
)



// WEBPACK FOOTER //
// ./src/modules/Content/IndicatorEvolutionContainer/index.js